import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MaterialModule } from '@shared/angular-material';

import { BeeDialogNotificationComponent } from './bee-dialog-notification.component';

@NgModule({
  declarations: [
    BeeDialogNotificationComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule
  ],
  exports: [
    BeeDialogNotificationComponent
  ]
})
export class BeeDialogNotificationModule {
}
